import { Configuration } from '@/api/generated/fetch-client';
import { routeTree } from '@/app/routeTree.gen';
import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { ymHit } from '@/lib/analytics/ym';
import { recordNavigation } from '@/lib/navigation-history';

export const router = createRouter({
  routeTree,
  context: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    queryClient: undefined as any as QueryClient,
    configuration: new Configuration({
      basePath: '/api',
    }),
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: ({ location }) => {
    const state = location.state as unknown as Record<string, unknown> | undefined;
    if (state?.__drawer_id) return false;
    return true;
  },
});

let previousHref: string | undefined;
router.subscribe('onResolved', ({ toLocation }) => {
  ymHit(toLocation.href, {
    referer: previousHref,
    title: globalThis.document?.title,
  });
  previousHref = toLocation.href;

  const state = toLocation.state as { __TSR_index?: number } | undefined;
  const index = typeof state?.__TSR_index === 'number' ? state.__TSR_index : 0;
  recordNavigation(index, toLocation.pathname);
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  interface HistoryState {
    returnTo?: string;
  }
}

export type RoutePaths = keyof typeof router.routesByPath;
